<template>
  <div>

    <pageTable ref="snTable"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/company/cardSn"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="add_time">
          <DatePicker v-model="searchData.add_time" type="datetimerange" placeholder="消费时间" style="width: 320px"></DatePicker>
        </FormItem>
      </template>

    </pageTable>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";

  export default {
    name: "cardSn",
    components:{pageTable},
    props:{
      cardId:{
        type:Number,
        default: 0
      }
    },
    data() {
      return {
        searchData: {
          card_id:this.cardId,
          add_time:''
        },
        tableColumn: [
          {title: 'ID',key: 'sn_id',align: "center"},
          {title: '发生数量',key: 'amount',align: "center"},
          {title: '消费前数量',key: 'before_amount',align: "center"},
          {title: '消费后数量',key: 'after_amount',align: "center"},
          {title: '时间',key: 'add_time',align: "center"},
          {title: 'IP',key: 'add_ip',align: "center"},
          {title: '备注',key: 'remark',align: "center"},
        ],
        tableData: [],

      }
    },
    methods: {

    },
    mounted() {
    },
  }
</script>

<style scoped>

</style>
